// Конфигурация анимации секции "Наши преимущества" на главной странице

export const AdvantagesAnimationConfig = {
  // *** Основные параметры анимации ***

  // Длительность анимации каждого элемента в секундах
  duration: 0.4,

  // Функция плавности (easing function)
  ease: 'back.out(1.7)',

  // Начальное смещение элементов по оси Y в пикселях
  yOffset: 30,

  // *** НАСТРОЙКИ ДВУХФАЗНОЙ АНИМАЦИИ ***

  // ФАЗА 1: Появление секции
  // Задержка ПОСЛЕ того как секция полностью появилась в viewport
  sectionAppearanceDelay: 0.1,

  // ФАЗА 2: Анимация элементов ВНУТРИ секции
  // Общая задержка перед началом анимации элементов
  elementsStartDelay: 0.1,

  // Задержка перед первой карточкой в первом ряду
  firstRowStartDelay: 0.1,

  // Интервал между карточками первого ряда
  firstRowInterval: 0.1,

  // Задержка для карточки с изображением (левая колонка)
  imageCardDelay: 0.2,

  // Задержка перед первой карточкой в правой колонке
  featureCardsStartDelay: 0.2,

  // Интервал между карточками в правой колонке
  featureCardsInterval: 0.1,

  // *** Настройки для мобильных устройств (ширина ≤ 768px) ***
  mobileFirstRowInterval: 0.15,
  mobileFeatureCardsInterval: 0.15,

  // *** НАСТРОЙКИ INTERSECTION OBSERVER ***

  // Триггер для начала анимации (сколько процентов секции должно быть видно)
  // Увеличиваем до 0.8 чтобы анимация начиналась позже
  observerThreshold: 0.1,

  // Убираем отрицательный отступ - теперь анимация начинается ТОЛЬКО
  // когда секция уже хорошо видна
  observerRootMargin: '0px 0px 0px 0px',

  // *** CSS классы для управления анимацией ***
  animateOnScrollClass: 'animate-on-scroll',
  visibleClass: 'visible',

  // *** Дополнительные настройки ***
  useCSSTransitionFallback: false,
  useDataAttributes: true,
  mobileBreakpoint: 768,

  // *** НОВЫЕ НАСТРОЙКИ: Плавное появление ***

  // Увеличивать ли интервалы для более плавного появления
  enableSmoothReveal: true,

  // Множитель для увеличения интервалов (больше = медленнее и плавнее)
  smoothRevealMultiplier: 1.8,

  // Задержка между группами элементов (ряды, колонки)
  groupDelayIncrement: 0.1,
};
